const Disclaimer = () => null;

export default Disclaimer;
